import Echars from "./src/index.vue";
export default Echars;